const tableDesign = {
  containerBorder: "2px solid #a7a7a763",
  rowDivider: "1px solid #a7a7a763",
  headerBackground: "#dee4f9cb",
  headerColor: "#000000b4",
  headerFontWeight: 600,
};

export default tableDesign;
